export default "__VITE_ASSET__C1EW8bZV__"